import React from 'react';
import InputImage from './inputImage/index';

export function InputImageWithProcessing(props) {
  return <InputImage {...props} />;
}
